<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="parentFormGroup">
  <label>{{ 'TAGS_SELECT.TAGS' | translate }}</label>
  <ng-select
    [items]="data"
    [addTag]="addTagFn"
    bindLabel="name"
    [hideSelected]="true"
    multiple="true"
    [formControlName]="'tags'"
  >
  </ng-select>
</div>
